import useSWR from 'swr'

import { MutationOptions, useCallMutation } from '@/common/api/client'
import {
  CancelPuRunVars,
  CoveragePuVars,
  DetailPuVars,
  ListPuVars,
  ProductUnderstandingApiPath,
  PuCoverageResponse,
  PuDetailResponse,
  PuEstimateResponse,
  PuEstimateVars,
  PuListResponse,
  PuRun,
  PuRunsResponse,
  PuRunsVars,
  StartPuRunVars
} from '@/common/api/params/productUnderstanding'

export const useProductUnderstandingListApi = (vars: ListPuVars | undefined) => {
  return useSWR<PuListResponse, Response, [string, ListPuVars] | undefined>(
    vars ? [ProductUnderstandingApiPath.LIST, vars] : undefined
  )
}

export const useProductUnderstandingCoverageApi = (vars: CoveragePuVars | undefined) => {
  return useSWR<PuCoverageResponse, Response, [string, CoveragePuVars] | undefined>(
    vars ? [ProductUnderstandingApiPath.COVERAGE, vars] : undefined
  )
}

export const useProductUnderstandingDetailApi = (vars: DetailPuVars | undefined) => {
  return useSWR<PuDetailResponse, Response, [string, DetailPuVars] | undefined>(
    vars ? [ProductUnderstandingApiPath.DETAIL, vars] : undefined
  )
}


/** 実行前の見積り。画面はこれを取得してからでないと実行ボタンを押せない */
export const useProductUnderstandingEstimateApi = (vars: PuEstimateVars | undefined) => {
  return useSWR<PuEstimateResponse, Response, [string, PuEstimateVars] | undefined>(
    vars ? [ProductUnderstandingApiPath.ESTIMATE, vars] : undefined
  )
}

/** 実行履歴と進行中の進捗。進行中はポーリングで更新する */
export const useProductUnderstandingRunsApi = (
  vars: PuRunsVars | undefined,
  refreshInterval = 0
) => {
  return useSWR<PuRunsResponse, Response, [string, PuRunsVars] | undefined>(
    vars ? [ProductUnderstandingApiPath.RUNS, vars] : undefined,
    // 既定の fetcher を使う。`undefined` では型が通らないので null を渡す
    null,
    { refreshInterval }
  )
}

export const useStartProductUnderstandingRunApi = (options?: MutationOptions<PuRun>) => {
  return useCallMutation<PuRun, StartPuRunVars>(ProductUnderstandingApiPath.RUNS, options)
}

export const useCancelProductUnderstandingRunApi = (options?: MutationOptions<PuRun>) => {
  return useCallMutation<PuRun, CancelPuRunVars>(
    ProductUnderstandingApiPath.CANCEL_RUN,
    options
  )
}
